import api from "./api";

const employeeAttendanceService = {
  getMarkingSheet: (params) => api.get("/employee-attendance/marking-sheet", { params }),
  markAttendance: (data) => api.post("/employee-attendance/mark", data),
  getReport: (params) => api.get("/employee-attendance/report", { params }),
};

export default employeeAttendanceService;
